




























































import {RideCreditProfile} from '@/types/entity';
import {Component, Vue} from 'vue-property-decorator';
import DataTable from '../../components/DataTable.vue';
import {ObjectFactory} from '@/config/objectFactory';
import {ApiRequest, QueryRecordsRequest} from '@/types/request';
import {MedTransGoConstants} from '@/util/constants';
// tslint:disable-next-line:no-var-requires
const RideCreditActivitytatable = require('../../datatable/RideCreditActivityLog.json');
// tslint:disable-next-line:no-var-requires
const RideCreditUsageDatatable = require('../../datatable/CreditUsageTable.json');

@Component({
    data() {
        return {
            imagePreview: '',
        };
    },
    components: {
        DataTable,
    },
    props: {
        rideCreditProfile: {
            type: Object,
            required: true,
        },
        rideCreditMethod: {
            type: String,
            required: true,
        },
    },
})
export default class ViewRideCreditModal extends Vue {

    private show = true;
    private rideCreditActivityDataSource = RideCreditActivitytatable;
    private logStart = 0;
    private profileId = '';

    private mounted() {
        this.rideCreditActivityDataSource.data = [];
        const profileDetails: RideCreditProfile = this.$props.rideCreditProfile;
        if (profileDetails && profileDetails.id) {
            this.profileId = profileDetails.id;
        }
        this.getRideCreditActivityLogs('', 0);
    }

    private async getRideCreditActivityLogs(searchString?: string, start?: number) {
        try {
            if (typeof start !== 'undefined') {
                this.logStart = start;
            } else if (this.logStart > 0) {
                start = this.logStart;
            }
            const iHttpService = ObjectFactory.getHttpService();
            const queryRecordsRequest: QueryRecordsRequest = {
                limit: MedTransGoConstants.PAGINATION_LIMIT,
                conditions: [],
                start,
            };
            const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_ORGANIZATIONS}/${this.profileId}/ride-credit-logs`,
                data: queryRecordsRequest,
                loaderEvent : {
                    show: true,
                },
            };
            const response = await iHttpService.post<any>(apiRequest);
            if (response.success && response.data) {
                this.rideCreditActivityDataSource.data = response.data;
            }
            if (response.totalCount) {
                this.rideCreditActivityDataSource.totalCount = response.totalCount;
            }
        } catch (error) {
            throw error;
        }
    }

    private close() {
        this.$emit('close');
    }

}
